import { render, staticRenderFns } from "./StudentInRoomForm.vue?vue&type=template&id=1c4dad9e&scoped=true&"
import script from "./StudentInRoomForm.vue?vue&type=script&lang=ts&"
export * from "./StudentInRoomForm.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInRoomForm.vue?vue&type=style&index=0&id=1c4dad9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4dad9e",
  null
  
)

export default component.exports